import api from "./api";

/**
 * Get all settings with categories
 */
export const getSettings = async () => {
  try {
    const response = await api.get("/api/settings/categories");
    return response.data;
  } catch (error) {
    console.error("[Settings Service] Error fetching settings:", error);
    throw error;
  }
};

/**
 * Update settings
 */
export const updateSettings = async (settings) => {
  try {
    const response = await api.put("/api/settings", settings);
    return response.data;
  } catch (error) {
    console.error("[Settings Service] Error updating settings:", error);
    throw error;
  }
};

/**
 * Reset settings to defaults
 */
export const resetSettings = async () => {
  try {
    const response = await api.delete("/api/settings");
    return response.data;
  } catch (error) {
    console.error("[Settings Service] Error resetting settings:", error);
    throw error;
  }
};
